import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3a1173a2"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "选择不符合的类型", -1));
const _hoisted_2 = {
  class: "content"
};
import BaseRule from "../BaseRule.vue";
import { computed, ref } from "vue";
export default {
  __name: 'CompanyType',
  props: ["index", "item", "data"],
  setup(__props) {
    const props = __props;
    const data = computed(() => props.data);
    const index = computed(() => props.index);
    const item = computed(() => props.item);
    const word = {
      name: "CompanyType"
    };
    return (_ctx, _cache) => {
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      return _openBlock(), _createBlock(BaseRule, {
        word: word,
        index: _unref(index),
        data: _unref(data)
      }, {
        default: _withCtx(() => [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_checkbox_group, {
          modelValue: _unref(item).value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(item).value = $event),
          class: "margin"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_checkbox, {
            label: "合作社",
            value: "0"
          }), _createVNode(_component_el_checkbox, {
            label: "个体工商户",
            value: "1"
          }), _createVNode(_component_el_checkbox, {
            label: "律师事务所",
            value: "2"
          }), _createVNode(_component_el_checkbox, {
            label: "会计师事务所",
            value: "3"
          }), _createVNode(_component_el_checkbox, {
            label: "股份制公司",
            value: "4"
          }), _createVNode(_component_el_checkbox, {
            label: "分公司",
            value: "5"
          })]),
          _: 1
        }, 8, ["modelValue"])])]),
        _: 1
      }, 8, ["index", "data"]);
    };
  }
};